/**
 * This repository is relatively unmaintained, so there are some long standing issues with the
 * phone mask backspace working with guide set to false. This is a work around that will work
 * for as long as we are using a US phone number mask.
 *
 * https://github.com/text-mask/text-mask/issues/483#issuecomment-337259727
 */
var maskMaker = function maskMaker(mask, nonCharactersList) {
  return function (raw) {
    var length = raw.length;
    var nonDefault = nonCharactersList.some(function (characterIndex) {
      return characterIndex === length;
    });
    return nonDefault ? mask.slice(0, length) : mask;
  };
};

var mask = maskMaker(['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/], [4, 9]);

export default mask;
//# sourceMappingURL=mask.js.map
